/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetSummaryDeclarationsResponseJson } from './get-summary-declarations-response-json';
import { GetSummaryDeclarationsResult } from '../results/get-summary-declarations-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { SummaryDeclarationDto } from '../models/summary-declaration-dto';
import { SummaryDeclarationSubtypeDto } from '../models/summary-declaration-subtype-dto';
import { SpecificInformationDto } from '../models/specific-information-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetSummaryDeclarationsResponse extends ResponseWithErrorGeneric<GetSummaryDeclarationsResponseJson, GetSummaryDeclarationsResult> implements IResponseWithErrorGeneric<GetSummaryDeclarationsResult> {
  public summaryDeclarations: SummaryDeclarationDto[];
  public summaryDeclarationSubtypes: SummaryDeclarationSubtypeDto[];
  public specificInformationCodes: SpecificInformationDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetSummaryDeclarationsResponse>) {
    super(response, GetSummaryDeclarationsResult.Error);
    if (this.result !== GetSummaryDeclarationsResult.Success) {
      return;
    }

    this.summaryDeclarations = this.body.summaryDeclarations;
    this.summaryDeclarationSubtypes = this.body.summaryDeclarationSubtypes;
    this.specificInformationCodes = this.body.specificInformationCodes;
  }
  //</custom-body>
}
